import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icon.d.ts').IconClose}
 */
const IconClose = () => {
    return (
        <svg
            aria-hidden='true'
            fill='none'
            height='32'
            viewBox='0 0 20 20'
            width='32'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M6.0618 14.4224L5.57617 13.9368L9.51367 9.9993L5.57617 6.0618L6.0618 5.57617L9.9993 9.51367L13.9368 5.57617L14.4224 6.0618L10.4849 9.9993L14.4224 13.9368L13.9368 14.4224L9.9993 10.4849L6.0618 14.4224Z'
                fill='currentColor' />
        </svg>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default IconClose;
